import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { api } from '../utils/request';

export type Region = 'CN' | 'GLOBAL';

export interface RegionInfo {
  region: Region;
  displayName: string;
  currency: string;
  currencySymbol: string;
  availablePaymentMethods: string[];
}

interface RegionState {
  region: Region;
  regionInfo: RegionInfo | null;
  detected: boolean;
  loading: boolean;
  setRegion: (region: Region) => void;
  setRegionInfo: (info: RegionInfo) => void;
  fetchRegion: () => Promise<void>;
  switchRegion: (region: Region) => Promise<void>;
}

export const useRegionStore = create<RegionState>()(
  persist(
    (set, get) => ({
      region: 'GLOBAL',
      regionInfo: null,
      detected: false,
      loading: false,

      setRegion: (region) => {
        set({ region });
      },

      setRegionInfo: (info) => {
        set({ regionInfo: info, region: info.region as Region, detected: true });
      },

      fetchRegion: async () => {
        const { detected } = get();
        if (detected) return;

        set({ loading: true });
        try {
          const info = await api.get<RegionInfo>('/region');
          set({ regionInfo: info, region: info.region as Region, detected: true, loading: false });
        } catch {
          set({ region: 'GLOBAL', detected: true, loading: false });
        }
      },

      switchRegion: async (region) => {
        set({ loading: true });
        try {
          await api.post('/region', { region });
          set({ region });
          const info = await api.get<RegionInfo>('/region');
          set({ regionInfo: info });
        } catch {
          set({ loading: false });
        }
      },
    }),
    {
      name: 'kimap-user-region',
      partialize: (state) => ({ region: state.region, detected: state.detected }),
    }
  )
);
